import { render, staticRenderFns } from "./NextIcon.vue?vue&type=template&id=3676fa11"
import script from "./NextIcon.vue?vue&type=script&lang=js"
export * from "./NextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports